import { tx } from '../i18n';
/**
 * El radar de la marca: el mismo de KNOC360. Da una vuelta cada 15 s y los puntos se
 * encienden al pasar la aguja. `quieto`: se detiene — acá quiere decir que el Centro no
 * pudo hablar con su API, no que un appliance se haya caído.
 */
export function Logo({ quieto = false, titulo = 'KNOC360' }: { quieto?: boolean; titulo?: string }) {
  return (
    <svg className={`k-logo${quieto ? ' quieto' : ''}`} viewBox="0 0 512 512" role="img" aria-label={titulo}>
      <defs>
        <linearGradient id="k-barrido" gradientUnits="userSpaceOnUse" x1="107.7" y1="196.1" x2="256" y2="96">
          <stop offset="0" stopColor="#3CC4BF" stopOpacity="0" />
          <stop offset="1" stopColor="#3CC4BF" stopOpacity=".62" />
        </linearGradient>
      </defs>
      <path d="M199.04 18.74 A244 244 0 0 1 404.54 62.42 L387.82 139.38 A176 176 0 0 0 248.32 80.17 Z" fill="#4D5B9B" />
      <path d="M432.99 88.04 A244 244 0 0 1 497.91 287.85 L422.90 311.85 A176 176 0 0 0 404.44 161.44 Z" fill="#D33F2B" />
      <path d="M489.95 325.30 A244 244 0 0 1 349.37 481.43 L291.09 428.47 A176 176 0 0 0 412.11 337.27 Z" fill="#F3A60F" />
      <path d="M312.96 493.26 A244 244 0 0 1 107.46 449.58 L124.18 372.62 A176 176 0 0 0 263.68 431.83 Z" fill="#76AC3F" />
      <path d="M79.01 423.96 A244 244 0 0 1 14.09 224.15 L89.10 200.15 A176 176 0 0 0 107.56 350.56 Z" fill="#0E8889" />
      <path d="M22.05 186.70 A244 244 0 0 1 162.63 30.57 L220.91 83.53 A176 176 0 0 0 99.89 174.73 Z" fill="#0569A2" />
      <circle cx="333.29" cy="186.41" r="19" fill="#76AC3F" className="k-punto" style={{ animationDelay: '-14.299s' }} />
      <circle cx="315.00" cy="358.19" r="19" fill="#F3A60F" className="k-punto" style={{ animationDelay: '-13.663s' }} />
      <circle cx="193.58" cy="312.21" r="19" fill="#D33F2B" className="k-punto" style={{ animationDelay: '-13.237s' }} />
      <circle cx="175.70" cy="166.82" r="19" fill="#76AC3F" className="k-punto" style={{ animationDelay: '-12.653s' }} />
      <g className="k-giro">
        <path d="M256 256 L107.65 196.06 A160 160 0 0 1 256.00 96.00 Z" fill="url(#k-barrido)" />
        <line className="k-aguja" x1="256" y1="256" x2="256" y2="96" strokeWidth="14" strokeLinecap="round" />
      </g>
      <circle className="k-centro" cx="256" cy="256" r="24" />
    </svg>
  );
}

/** La marca del panel. Acá el producto no es el appliance: es el Centro que los cuida. */
export function Marca() {
  return (
    <div className="marca">
      <Logo />
      <div>
        <div className="marca-nombre">
          KNOC<b>360</b> <i>{tx.ingreso.marca.replace('· ', '')}</i>
        </div>
        <span className="marca-firma">
          by <span>Kuanta Bridge</span>
        </span>
      </div>
    </div>
  );
}
